import React from 'react';
import { AlertModal } from '@common/alert_modal';
import { getAdvisorSlug } from '../../../project_items/helper_functions';

function NotInLiveMode({
  cancelChat,
  errors,
  loadAdvisor,
  advisorId
}) {
  const onCancel = () => {
    cancelChat();
    if (advisorId) {
      loadAdvisor(getAdvisorSlug({ advisorId }));
    }
  };

  return (
    <AlertModal onClose={ onCancel } title={ errors[0] } />
  );
}

export default NotInLiveMode;
